import { InputGroup, Form, Button } from "react-bootstrap";
import { X } from "react-feather";
import { useAsyncDebounce } from "react-table";
import { useState, useEffect } from "react";

const DefaultColumnFilter = ({ column }) => {
  const { filterValue, setFilter, Header: header } = column;
  const [value, setValue] = useState(filterValue);

  useEffect(() => {
    !filterValue && setValue(undefined);
  }, [filterValue]);

  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 200);

  return (
    <InputGroup className="mb-3">
      <Form.Control
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`Search ${header}...`}
      />
      {value && (
        <Button
          variant={value ? "danger" : "outline-secondary"}
          disabled={!value}
          onClick={() => {
            setValue(undefined);
            onChange(undefined);
          }}
        >
          <X size={16} />
        </Button>
      )}
    </InputGroup>
  );
};

export default DefaultColumnFilter;
